import { ImageProps } from "./image";

export type TObituaryComponent = {
  name: string;
  photo: ImageProps;
  birthDate: string;
  deathDate: string;
  location: string;
  slug: string;
};

export type TObituaryFull = {
  id?: string;
  name: string;
  websiteTemplate: TObituaryTemplate;
  photo?: TObituaryImage | null;
  bio: string;
  birthDate: string;
  deathDate: string;
  location: string;
  slug: string;
  funeralDetails: string;
  gallery: TObituaryImage[];
  serviceLocation: TObituaryLocation | null;
  receptionLocation: TObituaryLocation | null;
  published?: boolean;
  displayAffiliate?: string;
  isCustomer?: boolean;
};

export type TObituaryTemplate = {
  type: "solid" | "image";
  style: string;
  image?: string;
};

export type TObituaryLocation = {
  address?: string;
  time: string;
  date: string;
  mainInfo: string;
  alternativeInfo: string;
  latitude?: string;
  longitude?: string;
  location?: TObituaryLocationValues;
};
export type TObituaryLocationValues = {
  route: string;
  street_number: string;
  locality: string;
  postal_code: string;
  lat: string;
  lng: string;
  name: string;
};

export type TObituaryImage = {
  url: string;
  width: number;
  height: number;
};

export type TObituaryListItem = {
  name: string;
  photo?: ImageProps;
  birthDate: string;
  deathDate: string;
  location: string;
  slug: string;
  tributesCounter: {
    CANDLE?: number;
    FLOWER?: number;
    DOVE?: number;
    STAR?: number;
  };
  totalComments: number;
};

export type TObituaryRemoteTribute = {
  CANDLE?: TObituaryTributeItem[];
  DOVE?: TObituaryTributeItem[];
  FLOWER?: TObituaryTributeItem[];
  STAR?: TObituaryTributeItem[];
};

export type TObituaryTributeItem = {
  tributeType: string;
  name: string;
};

export type TObituaryList = {
  page: number;
  total: number;
  term?: string;
  totalPages: number;
  entries: TObituaryListItem[];
};

export type TObituaryTributesItem = {
  name: string;
  icon: string;
};

export const TObituaryTributesList: TObituaryTributesItem[] = [
  {
    name: "CANDLE",
    icon: "https://res.cloudinary.com/dkyl4jbxx/image/upload/v1708520447/candle_ded9feec69.png",
  },
  {
    name: "DOVE",
    icon: "https://res.cloudinary.com/dkyl4jbxx/image/upload/v1708520447/dove_2d21f85ef0.png",
  },
  {
    name: "FLOWER",
    icon: "https://res.cloudinary.com/dkyl4jbxx/image/upload/v1708520447/flower_55a570038b.png",
  },
  {
    name: "STAR",
    icon: "https://res.cloudinary.com/dkyl4jbxx/image/upload/v1708520447/star_0d1e3dafd6.png",
  },
];

export type TObituaryBook = {
  comments?: TObituaryBookItem[];
  page?: {
    size: number;
    totalElements: number;
    totalPages: number;
    number: number;
  };
};

export type TObituaryBookItem = {
  uuid: string;
  id: string;
  slug: string;
  name: string;
  email?: string;
  image?: TObituaryImage;
  timestamp: string;
  message: string;
  replies?: TObituaryBookReplyItem[];
};

export type TObituaryBookReplyItem = {
  name: string;
  commentUuid: string;
  message: string;
  timestamp: string;
  email?: string;
};

export type TObituaryAdmin = {
  obituary: TObituaryFull | null;
  saveCall: (obituary: TObituaryFull, callBack: () => void) => void;
};

export type TObituaryAdminList = {
  entries: TObituaryFull[];
  total: number;
  page: number;
  size: number;
};
